import { toast } from "react-toastify";
import { FtlRouteViewModel } from "../../ViewModel/FtlRouteViewModel";
import { ProjectStateType } from "../EditProjectContext";
import { getPdsrById } from "./getPdsrById";
import { getPdsrOnRouteById } from "./getPdsrOnRouteById";
import { setPdsrsOnThisRoute } from "./setPdsrsOnThisRoute";
import getRoutingInfo from "../../GetRoutingInfo";
import { CardType } from "../LeftSide/CardType";
import { updatePdsrFTLIdentifier } from "./updatePdsrFTLIdentifier";
import { insertDragNDropCardToRoute } from "./insertDragNDropCardToRoute";
import { PuDo } from "../../ViewModel/PuDo";
import { GetRoutingTypeDisplayName, RoutingType } from "../../ViewModel/RoutingType";
import { getOdcs } from "./getOdcs";
import { PdsrClientViewModel } from "../../ViewModel/PdsrClientViewModel";
import { RelationType } from "../../../TransportNetwork/RelationType";
import { updateOdcsForSpdrAndPdsrOnRoute } from "../RightSide/FtlTab/updateOdcsForSpdrAndPdsrOnRoute";
import { RouteType } from "../../ViewModel/RouteType";

export async function handlePdsr(
  draggableId: string,
  route: FtlRouteViewModel,
  routeId: number,
  projectState: ProjectStateType,
  pdsrId: number
) {
  const { project } = projectState;
  if (route.RouteType === "Trunk") {
    toast(`PDSR cannot added on Route with Type Trunk`, {
      type: "error",
    });
    return;
  }

  const draggedPdsr = getPdsrById(pdsrId, project);
  if (!draggedPdsr) {
    toast(`Error while try to add PDSR`, {
      type: "error",
    });
    return;
  }

  const { Supplier, Plant } = await getRoutingInfo(
    project.ProjectId || -1,
    draggedPdsr.SupplierGsdb,
    draggedPdsr.PlantGsdb,
    draggedPdsr.DockCode,
    RelationType.Pdsr,
    CardType.pdsr
  );

  if (
    Plant.RoutingType !== RoutingType.Plant &&
    Plant.RoutingType !== RoutingType.EPC &&
    Plant.RoutingType !== RoutingType.ODC &&
    Plant.RoutingType !== RoutingType.EDC
  ) {
    toast(
      `Error while try to add PDSR: Location Type ${GetRoutingTypeDisplayName(
        Plant.RoutingType
      )} for Plant ${Plant.Gsdb} is not allowed `,
      {
        type: "error",
      }
    );
    return;
  }

  if (
    Supplier.RoutingType !== RoutingType.Supplier &&
    Supplier.RoutingType !== RoutingType.ODC &&
    Supplier.RoutingType !== RoutingType.EDC
  ) {
    const message = `Error while try to add PDSR: Location Type ${GetRoutingTypeDisplayName(
      Supplier.RoutingType
    )} for Supplier ${Supplier.Gsdb} is not allowed `;
    toast(message, {
      type: "error",
    });
    return;
  }

  const pdsrsOnThisRoute = route.PdsrsOnThisRoute || [];
  const pdsrOnRoute = getPdsrOnRouteById(pdsrsOnThisRoute, pdsrId);
  if (pdsrOnRoute) {
    toast(`Error while try to add PDSR`, {
      type: "error",
    });
    return;
  }

  if (draggedPdsr.ShipFrequency === 0) {
    draggedPdsr.ShipFrequency = 11;
  }

  const odcs = getOdcs(route.RoutingTable);

  if (
    Supplier.RoutingType === RoutingType.ODC &&
    (route.RouteType === RouteType.FTL2 || route.RouteType === RouteType["Top-Up"])
  ) {
    odcs.push({ OdcGsdb: Supplier.Gsdb });
    updateOdcsForSpdrAndPdsrOnRoute(route, Supplier.Gsdb);
  }

  if (
    Plant.RoutingType === RoutingType.ODC &&
    (route.RouteType === RouteType.FTL2 || route.RouteType === RouteType["Top-Up"])
  ) {
    odcs.push({ OdcGsdb: Plant.Gsdb });
    updateOdcsForSpdrAndPdsrOnRoute(route, Plant.Gsdb);
  }

  const newPdsr: PdsrClientViewModel = {
    ...draggedPdsr,
    ODCs: odcs,
  };
  pdsrsOnThisRoute.push(newPdsr);

  if (draggedPdsr.UsedInFtlRoutes) {
    draggedPdsr.UsedInFtlRoutes += 1;
  }

  setPdsrsOnThisRoute(
    {
      project: updatePdsrFTLIdentifier(project),
      setProject: projectState.setProject,
    },
    routeId,
    pdsrsOnThisRoute
  );

  insertDragNDropCardToRoute(
    draggedPdsr,
    route,
    { ...Supplier, PuDoType: PuDo.DO_R },
    { ...Plant, PuDoType: PuDo.PU_R },
    projectState
  );
}
